import { Button, Icon } from "@portal/components/primitives";

export const QuickSubmitLayout = ({
	children,
	header,
	openFullSubmission,
	fullSubmissionTrackingId,
}: {
	children: React.ReactNode;
	header: React.ReactNode;
	openFullSubmission: () => void;
	fullSubmissionTrackingId?: string;
}) => {
	return (
		<div className="relative">
			<div
				className="h-14 min-w-[800px] flex flex-row justify-between items-center px-5 py-4 border-b border-bc-default text-sm"
				data-testid="quick-submit-layout"
			>
				{header}
				<Button
					variant="ghost"
					onClick={openFullSubmission}
					trackingId={fullSubmissionTrackingId}
					className="inline-flex items-center gap-2 h-auto px-0 text-xs text-brand-accent font-[550] hover:text-brand-primary"
				>
					Full Submission <Icon type="arrows-pointing-out" size="micro" />
				</Button>
			</div>
			{/* Header is h-14, so the scroll area is capped to keep the whole popover at 70vh. */}
			<div className="p-4 w-full h-full max-h-[calc(70vh-3.5rem)] overflow-y-auto">{children}</div>
		</div>
	);
};
